import { BORDER_STYLE } from "./excelReportStyles";
import { formatUnitForDisplay } from "../../../utils/Utils";

export const parseJSON = (data) => {
  if (!data) return {};
  try {
    return typeof data === "string" ? JSON.parse(data) : data;
  } catch {
    return {};
  }
};

export const formatPlantTrainName = (plantName, plantId, trainNum) =>
  `${plantName || "Plant"}(${plantId}) - Train ${trainNum}`;

export const addBordersToSheet = (sheet) => {
  sheet.eachRow((row) => {
    row.eachCell((cell) => {
      cell.border = BORDER_STYLE;
    });
  });
};

export const OPTIMIZATION_TARGET_MAP = {
  total_cost: "Maximize Financial Benefits",
  maximize_product: "Maximize Product",
  minimize_energy: "Minimize Energy Cost",
};

export const getCurrencySymbol = (currencyCode) => {
  const symbols = {
    USD: "$",
    Euro: "€",
    Yuan: "¥",
  };
  return symbols[currencyCode] || currencyCode;
};

export const parseBenchmarkTrainsData = (trainsData) =>
  trainsData
    .map((train) => {
      if (!train || typeof train !== "object") {
        return null;
      }

      return {
        train_num: train.train_num || 0,
        plant_id: train.plant_id || null,
        plant_name: train.plant_name || null,
        train_name: train.train_name || `Train ${train.train_num || 0}`,
        historic_cips: train.historic_cips || [],
        units: train.units
          ? {
              ...train.units,
              feed_quality: formatUnitForDisplay(train.units.feed_quality),
              permeate_quality: formatUnitForDisplay(
                train.units.permeate_quality,
              ),
              temperature: formatUnitForDisplay(train.units.temperature),
            }
          : null,
        optimization_target:
          OPTIMIZATION_TARGET_MAP[train.optimization_target] ||
          "Maximize Financial Benefits",
        ca_predictions: parseJSON(train.ca_predictions),
        cleaning_efficiency: train.cleaning_efficiency || null,
        fouling_data: train.fouling_data || null,
        ra_predictions: train.ra_predictions || null,
      };
    })
    .filter((train) => train !== null);

export const ANNUAL_BENEFIT_KEYS = [
  "annual_energy_saving_percent",
  "annual_energy_saving_dollars",
  "annual_chemical_saving_percent",
  "annual_chemical_saving_dollars",
  "annual_downtime_saving_percent",
  "annual_downtime_saving_dollars",
  "annual_downtime_saving_days",
  "annual_increased_production_percent",
  "annual_increased_production_dollars",
  "annual_increased_production",
  "annual_total_financial_benefits",
];

export const isEmptyExcelValue = (value) =>
  value === null || value === undefined || value === "";

export const emptyValueFormatterForExcel = (value) => {
  if (isEmptyExcelValue(value)) {
    return "-";
  }
  return value;
};

export const formatReasonWithProportion = (reason, proportion) => {
  if (!reason || reason === "-") return "-";
  if (!proportion || proportion <= 0) return reason;

  const propValue = parseFloat(proportion);
  const propFormatted =
    propValue < 10 && propValue % 1 !== 0
      ? `${propValue.toFixed(1)}%`
      : `${Math.round(propValue)}%`;
  return `${reason} (${propFormatted})`;
};

export const formatComparisonValue = (value) => {
  if (isEmptyExcelValue(value)) {
    return "-";
  }

  const numericValue = Number(value);
  if (Number.isNaN(numericValue)) {
    return String(value);
  }

  return numericValue.toFixed(2);
};
